import React, { useEffect, useState } from "react";
import { pxToRem } from "@/util/common";
import { createUseStyles } from "react-jss";
import { Image, Toast } from "antd-mobile";
import { RootState } from "@/redux/store";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import useCustomTranslation from "@/hooks/useTranslation";
import useRouter from "@/hooks/useRouter";

const Plan: React.FC<{
	unauthorized: boolean;
	evolutionData: Record<string, any>;
	onVisiblePopup: (visible: boolean) => void;
	onSubmit: (params: Object) => void;
}> = ({ unauthorized, evolutionData, onVisiblePopup, onSubmit }) => {
	const classes = useStyles();
	const { t } = useCustomTranslation();
	const { location } = useRouter();
	const userInfo = useSelector((state: RootState) => state.auth.userInfo);
	const { dataList: appConfig } = useSelector(
		(state: RootState) => state.config
	);
	const [evolutionValue, setEvolutionValue] = useState(0);
	const planConfig = appConfig?.vipConfig[userInfo?.level ?? 0];
	const [userData, setUserData] = useState<Record<string, any>>({});

	const isModifyHandle = () => {
		let bool = true;
		if (unauthorized) {
			bool = false;
		} else if (!isEmpty(userData) && !isEmpty(evolutionData)) {
			bool = false;
		}
		return bool;
	};
	const handleIncrementDecrement = (amount: number) => {
		if (!isModifyHandle()) {
			Toast.show({
				content: t("NoPermissionModify"),
				position: "top",
			});
			return;
		}
		const maxValue = planConfig?.rate || 0.2;
		setEvolutionValue((prevValue) => {
			const newValue = prevValue + amount;
			if (newValue > +maxValue) {
				Toast.show({
					content: t("MaxValue") + " " + maxValue,
					position: "top",
				});
			}
			return (
				Math.round(Math.max(0, Math.min(+maxValue, newValue)) * 100) /
				100
			);
		});
	};

	useEffect(() => {
		if (!isEmpty(evolutionData)) {
			setEvolutionValue(+evolutionData.evoWater);
		}
		const searchParams = new URLSearchParams(location.search);
		const paramUser = searchParams.get("user");
		if (!isEmpty(paramUser) && paramUser) {
			const parseUser = JSON.parse(paramUser);
			setUserData(parseUser);
		}
	}, []);

	return (
		<div className={classes.manageNumbers}>
			<header>
				<div
					className="closeIcon"
					onClick={() => {
						onVisiblePopup(false);
					}}
				>
					<Image
						src={require("@/assets/images/icons/back.png")}
						width={20}
						height={18}
					/>
				</div>
				<p>{t("AddPlan")}</p>
				<div
					className="determine"
					onClick={() => {
						if (!isModifyHandle()) {
							Toast.show({
								content: t("NoPermissionModify"),
								position: "top",
							});
							return;
						}
						onSubmit({
							evoWater: evolutionValue.toString(),
							time: isEmpty(evolutionData)
								? Date.now()
								: evolutionData.time,
						});
					}}
				>
					{t("Save")}
				</div>
			</header>
			<ul>
				<li>
					<p>{t("Evolution")}</p>
					<div className="inputWrap">
						<Image
							onClick={() => handleIncrementDecrement(-0.01)}
							src={require("@/assets/images/icons/sub.png")}
							width={32}
							height={32}
						/>
						<div className="inputBox">
							<span>{evolutionValue}%</span>
						</div>
						<Image
							onClick={() => handleIncrementDecrement(0.01)}
							src={require("@/assets/images/icons/add.png")}
							width={32}
							height={32}
						/>
					</div>
				</li>
			</ul>
			<div
				onClick={() => {
					onVisiblePopup(false);
				}}
				className="cancel"
			>
				<span>{t("Cancel")}</span>
			</div>
		</div>
	);
};

export default Plan;

const useStyles = createUseStyles({
	manageNumbers: {
		display: "flex",
		flexDirection: "column",
		borderTopLeftRadius: pxToRem(10),
		borderTopRightRadius: pxToRem(10),
		backgroundColor: "#1E212A",
		"& header": {
			position: "relative",
			height: pxToRem(58),
			lineHeight: pxToRem(58),
			textAlign: "center",
			fontSize: pxToRem(15),
			color: "#FFFFFF",
			borderBottom: "1px solid #2F3A62",
			"& .closeIcon": {
				position: "absolute",
				top: "50%",
				left: pxToRem(15),
				transform: "translateY(-50%)",
			},
			"& .determine": {
				position: "absolute",
				top: "50%",
				right: pxToRem(14),
				color: "#4B6DE3",
				transform: "translateY(-50%)",
			},
		},
		"& ul": {
			flex: 1,
			overflowY: "auto",

			"& >li": {
				height: pxToRem(68),
				display: "flex",
				alignItems: "center",
				padding: {
					left: pxToRem(20),
					right: pxToRem(30),
				},
				justifyContent: "space-between",
				borderBottom: "1px solid #2F3A62",
				"& p": {
					flex: 1,
					fontSize: pxToRem(14),
					fontWeight: "400",
					color: "#FFFFFF",
					overflow: "hidden",
				},
				"& .inputWrap": {
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					"& .inputBox": {
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						height: pxToRem(35),
						width: pxToRem(108),
						color: "#FFFFFF",
						fontSize: pxToRem(18),
						fontWeight: pxToRem(500),
						borderRadius: pxToRem(8),
						margin: {
							left: pxToRem(10),
							right: pxToRem(10),
						},
						border: "1px solid #4C66C7",
						backgroundColor: "#181A22",
					},
				},
			},
		},
		"& .cancel": {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			height: pxToRem(88),
			color: "#FF6161",
			fontSize: pxToRem(18),
			fontWeight: "500",
		},
	},
});
